import React, { useEffect, useState, useRef } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { Button } from "antd";
import { getMonthlyBACandDrinksApi } from "../../api/api";

const RealTimeMonitoring = (props) => {
  const [data, setData] = useState([]);
  const chartRef = useRef(null); // Create a ref for the chart

  const transformData = (apiData) => {
    return apiData.breathalyzerReadings.map((reading, index) => ({
      day: index + 1,
      BrAC: reading,
      drinks: apiData.drinks[index],
    }));
  };

  const fetchData = async () => {
    const res = await getMonthlyBACandDrinksApi(props.user);
    const transformedData = transformData(res);
    setData(transformedData);
  };

  useEffect(() => {
    fetchData();
  }, [props.user]);

  const exportPDF = () => {
    if (chartRef.current) {
      html2canvas(chartRef.current)
        .then((canvas) => {
          const imgData = canvas.toDataURL("image/png");
          const pdf = new jsPDF({
            orientation: "landscape",
          });

          const headers = [["Name", "Age", "Total Breathalyzers"]];
          const rowData = [
            [props.patientInfo.name, props.patientInfo.age, props.breathalyzer],
          ];

          pdf.autoTable({
            head: headers,
            body: rowData,
            startY: 20,
          });

          const chartStartY = pdf.lastAutoTable.finalY + 10;
          pdf.addImage(imgData, "PNG", 20, chartStartY, 200, 160);

          pdf.save("chart.pdf");
        })
        .catch((err) => {
          console.error("Error exporting PDF: ", err);
        });
    }
  };

  return (
    <div>
      <h2 style={{ color: "grey" }}>
        BrAC and Standard Drink consumption in last 30 days
      </h2>
      <div ref={chartRef}>
        <LineChart
          width={600}
          height={300}
          data={data}
          margin={{ top: 10, right: 30, left: 20, bottom: 5 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="day" />
          <YAxis
            yAxisId="right"
            orientation="right"
            label={{ value: "BrAC", angle: -90, position: "insideRight" }}
          />
          <YAxis
            yAxisId="left"
            orientation="left"
            label={{ value: "Drinks", angle: -90, position: "insideLeft" }}
          />
          <Tooltip />
          <Legend />
          <Line
            yAxisId="right"
            type="monotone"
            dataKey="BrAC"
            stroke="#8884d8"
            strokeWidth={2}
            activeDot={{ r: 8 }}
          />
          <Line
            yAxisId="left"
            type="monotone"
            dataKey="drinks"
            stroke="#82ca9d"
            strokeWidth={2}
          />
        </LineChart>
      </div>
      <div style={{ textAlign: "right" }}>
        <Button onClick={exportPDF}>Export as PDF</Button>
      </div>
    </div>
  );
};

export default RealTimeMonitoring;
